// React
import React from "react";

// i18n
import { useTranslation } from "react-i18next";

// Material UI
import { Typography, Box, Card } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

// styles
import { styles } from "./styles";

const HowItWorksCard = () => {
  const { t } = useTranslation();

  const howItWorksData = [
    {
      altText: "Profile",
      imgSrc: "/profile.png",
      secondaryTitle: "howItWorksCard.step1",
      description: "howItWorksCard.createProfile",
    },
    {
      altText: "Search Icon",
      imgSrc: "/search.png",
      secondaryTitle: "howItWorksCard.step2",
      description: "howItWorksCard.searchAppointments",
    },
    {
      altText: "Calendar Icon",
      imgSrc: "/calendar.png",
      secondaryTitle: "howItWorksCard.step3",
      description: "howItWorksCard.bookAppointment",
    },
  ];

  return (
    <Box sx={styles.centeredBox}>
      <Card sx={styles.card}>
        <Typography sx={styles.title}>{t("howItWorksCard.title")}</Typography>
        <Grid2 container sx={styles.stepsGrid}>
          {howItWorksData.map((step) => (
            <Grid2 key={step.altText} container sx={styles.stepGrid}>
              <Box sx={styles.iconBox}>
                <img alt={step.altText} src={step.imgSrc} />
              </Box>
              <Box sx={styles.typographyBox}>
                <Typography sx={styles.secondaryTitle}>
                  {t(step.secondaryTitle)}
                </Typography>
                <Typography sx={styles.description}>
                  {t(step.description)}
                </Typography>
              </Box>
            </Grid2>
          ))}
        </Grid2>
      </Card>
    </Box>
  );
};

export default HowItWorksCard;
